import axios from "axios";

export const alertSettingsActions = () => async (dispatch) => {
  let token = localStorage.getItem("token").replace(/^"(.*)"$/, '$1');
  dispatch({ type: "ALERT_SETTINGS_LOADING" });
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/global/getAllListGlobalAppSetting`,
      { headers: 
        {
        'Authorization': 'Bearer ' + token,
        } }
    );
    
    const settingsArray = response.data.allGlobalSettings || [];
    if (response.status === 200) {
      dispatch({
        type: "ALERT_SETTINGS_SUCCESS",
        payload: settingsArray,
      });
    }
  } catch (error) {
    dispatch({
      type: "ALERT_SETTINGS_ERROR",
      payload: error.response,
    });
  }
};

export const updateAlertSettingAction = (payload) => async (dispatch) => {
  let token = JSON.parse(localStorage.getItem("token"));
  dispatch({ type: "ALERT_SETTINGS_UPDATE_LOADING" });
  
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/global/updateGlobalSettingCode`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    
    if (response.data && response.data.success) {
      dispatch(alertSettingsActions());
      dispatch({ type: "ALERT_SETTINGS_UPDATE_SUCCESS" });
    }
  } catch (error) {
    dispatch({
      type: "ALERT_SETTINGS_UPDATE_ERROR",
      payload: error.response,
    });
  }
};

export const resetAlertSettingsUpdate = () => ({
  type: "RESET_ALERT_SETTINGS_UPDATE"
});